import {ScanStyleDTO} from "./scanStyleDTO.interface";
import {BaseIntDTO} from "../_baseIntDTO.interface";

export interface ScanServiceDTO extends BaseIntDTO {

  serviceName?: string;
  identify?: string;
  scanStyles?: ScanStyleDTO[];
}
